module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_v",
      "title": "v"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "toclink_v"
    }
  }, [_vm._v("PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "drop-cap pcalibre"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("All")]), _vm._v(" save one of the papers here collected were\nwritten as lectures and read from a desk at\nCambridge; the exception being that upon Trollope,\ncontributed to "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("The Nation and the Athenaeum")]), _vm._v(" and\npleasantly provoked by a recent edition of the “Barsetshire”\nnovels. To these it almost wholly confines\nitself. But a full estimate of Trollope as one of our\ngreatest English novelists—and perhaps the raciest of\nthem all—is long overdue, awaiting a complete edition\nof him. His bulk is a part of his quality: it can no more\nbe separated from the man than can Falstaff’s belly\nfrom Falstaff. He will certainly come to his own\nsome day, but this implies his coming with all his\nmerits and all his defects: and this again cannot happen\nuntil some publisher shows enterprise. The expensive\nand artificial vogue of the three-volume-novel did wonders\nfor Trollope in one generation, to kill him for\nanother: since no critic can talk usefully about books\nto many of which his hearers have no access. But we\nshall see Trollope reanimated.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The papers on Dickens and Thackeray attempt\njudgment on them as full novelists. Those on Disraeli\nand Mrs. Gaskell merely take a theme, and try to\nshow how one theme, taking possession, will work upon\ntwo very different minds. Much more could have\nbeen said generally upon both authors, and generically\nupon the “idea” of a novel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_vi",
      "title": "vi"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("As usual, with a few corrections, I leave these lectures\nas they were written and given, at intervals and\nfor their purpose. They abound therefore with repetitions\nand reminders which the reader must try to\nforgive.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("\nARTHUR QUILLER-COUCH.\n")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("January 5, 1925.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0